import { debounce } from 'lodash';
import { useRef, useState, useLayoutEffect, useEffect } from 'react';

export function useContainerTopValue() {
  const containerRef = useRef<HTMLDivElement>(null);
  const [containerTopValue, setContainerTopValue] = useState(0);
  useEffect(() => {
    const handleResize = debounce(() => {
      if (containerRef.current) {
        const top = containerRef.current.offsetTop;
        if (containerTopValue !== top) {
          setContainerTopValue(top);
        }
      }
    }, 100);
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [containerTopValue]);
  // This should run on every render to ensure the top value is always up to date
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useLayoutEffect(() => {
    if (containerRef.current) {
      const top = containerRef.current.offsetTop;
      if (containerTopValue !== top) {
        setContainerTopValue(top);
      }
    }
  });

  return { containerRef, containerTopValue };
}
